import { PurchasedItem } from '../../../data/types/trade-item/purchased-item';
import {
  FIREARMS,
  NARCOTICS,
} from '../../../data/types/trade-item/trade-item-type';

export const hasIllegals = (cargo: PurchasedItem[]): boolean =>
  cargo.some((cargoItem) => [NARCOTICS, FIREARMS].includes(cargoItem.type));
